import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/not-found/NotFound.vue'
import Login from '@/views/common/login/Login.vue'
import PasswordSetting from '@/views/common/password/PasswordSetting.vue'
import adminRoutes from './routes/sys'
import dstrRoutes from './routes/dstr'
import chanRoutes from './routes/chan'
import openRoutes from './routes/open'
import store from "./stores/global";

const platform = localStorage.getItem('platform')
let routes = null

switch (platform) {
    case 'dstr':
        routes = dstrRoutes
        break
    case 'chan':
        routes = chanRoutes
        break
    default:
        routes = adminRoutes
}

routes.push({ path: '/login/:platform?', name: 'login', component: Login, meta: { title: '登录', auth: false } })
routes.push({ path: '/settings/password', name: 'password_setting', component: PasswordSetting, meta: { title: '修改密码', auth: true } })
routes = routes.concat(openRoutes)
routes.push({ path: '*', name: '404', component: NotFound })
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: routes
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    const name = localStorage.getItem('name')
    const platform = localStorage.getItem('platform')
    const prefix = platform !== 'sys' && name ? name + '-' : ''
    if (to.meta.title) {
        document.title = `${prefix}${to.meta.title}-短剧数据平台`
    }
    if (to.meta.auth && !token) {
        return router.push({
            name: 'login',
            query: {
                'platform': localStorage.getItem('platform')
            }
        })
    }
    next()
})


router.afterEach((to) => {
    store.commit('addOpenTab', to);
})

export default router
